import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import * as ST from './styled';

function Addresses(props) {
    const { dealersContacts, isOpenAddresses, updateOpenAddresses, city } = props;

    const address = dealersContacts?.map((item, index) => {
        return (
            <ST.AddressItem key={index} itemScope itemType='http://schema.org/LocalBusiness'>
                <meta itemProp='name' content='Дом.ru' />
                <meta itemProp='description' content={`Официальный сайт интернет-провайдера Дом.ru в ${city.cityIn}. Подключить быстрый Интернет, Цифровое HD-телевидение. Адреса и телефоны офисов. Выгодные тарифы и цены.`} />
                <div itemProp='address' itemScope itemType='http://schema.org/PostalAddress'>
                    <meta itemProp='addressCountry' content='Россия' />
                    <span itemProp='addressLocality'>{item.text}</span>
                </div>
                <meta itemProp='priceRange' content='200-2000RUB' />
                <meta itemProp='email' content='help@perm.ertelecom.ru' />
                <meta itemProp='telephone' content='+7 (342) 2-078-220' />
                <meta itemProp='url' content={`https://${city.domain}.dom.ru/`} />
                <meta itemProp='image' content='/static/images/domru.svg' />
                <meta itemProp='openingHours' content='Mo-Su 10:00-22:00' />
            </ST.AddressItem>
        );
    });

    return (
        <ST.AddressOverlay>
            <ST.AddressesContainer isOpen={isOpenAddresses}>
                <ST.AddressesTitle>Адреса</ST.AddressesTitle>
                <ST.AddressesClose onClick={() => {
                    updateOpenAddresses(false);
                }}/>
                    <ST.AddressesList>
                        {address}
                    </ST.AddressesList>
                <ST.AddressesLinkContainer>
                    <Link href='/service/contact'>
                        <ST.AddressesLink href='/service/contact'>Показать на карте</ST.AddressesLink>
                    </Link>
                </ST.AddressesLinkContainer>
            </ST.AddressesContainer>
        </ST.AddressOverlay>
    );
}

Addresses.propTypes = {
    dealersContacts: PropTypes.array,
    isOpenAddresses: PropTypes.bool,
};

Addresses.defaultProps = {
    dealersContacts: [],
    isOpenAddresses: false,
};

export default Addresses;
